export default "__VITE_ASSET__NOCaLTkD__"